export type ColorScheme = "light" | "dark";

export function readColorScheme(
  element: Element = document.documentElement
): ColorScheme {
  const scheme = getComputedStyle(element).colorScheme;
  if (scheme === "normal" && element !== document.documentElement)
    return "light";
  const light = scheme.includes("light");
  const dark = scheme.includes("dark");
  if (light !== dark) return dark ? "dark" : "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

const listeners = new Set<() => void>();
let observer: MutationObserver | undefined;
let media: MediaQueryList | undefined;

function notify() {
  for (const listener of listeners) listener();
}

export function onColorSchemeChange(listener: () => void) {
  if (listeners.size === 0) {
    observer = new MutationObserver(notify);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["style", "class"],
    });
    media = window.matchMedia("(prefers-color-scheme: dark)");
    media.addEventListener("change", notify);
  }
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) {
      observer?.disconnect();
      media?.removeEventListener("change", notify);
      observer = undefined;
      media = undefined;
    }
  };
}
